var map = {
	"./char1.png": 5078,
	"./char2.png": 100,
	"./char3.png": 5887,
	"./char4.png": 6194,
	"./char5.png": 1136,
	"./char6.png": 6812,
	"./char7.png": 7811,
	"./char8.png": 8674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7740;